import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

function usePrevious(value) {
  const ref = useRef(null);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export const RouteChangeListener = ({
  onChange,
  shouldFireOnInit = false,
  shouldFireOnAnchorChange = false,
}) => {
  const location = useLocation();
  const previousPathname = usePrevious(location.pathname);
  const previousHash = usePrevious(location.hash);

  useEffect(() => {
    const isInit = !previousPathname;
    const canTrackPathname = !isInit || shouldFireOnInit;

    if (
      (canTrackPathname && previousPathname !== location.pathname) ||
      (shouldFireOnAnchorChange && previousHash !== location.hash)
    ) {
      onChange(location, location.hash);
    }
  }, [
    shouldFireOnInit,
    shouldFireOnAnchorChange,
    location,
    onChange,
    previousHash,
    previousPathname,
  ]);

  return null;
};

export default RouteChangeListener;
